import numeral from "numeral";

export default function formatCurrency(amount, format = "0,0[.]00") {
  return "£" + (amount ? `${numeral(amount / 100).format(format)}` : 0);
}
